import { siteApiSlice } from "../../app/siteApiSlice";

export interface MessageViewModel {
	isMessageFromCurrentUser: boolean;
	senderId: number;
	senderInitials: string;
	senderHasImage: boolean;
	name: string;
	dateCreated: string;
	text: string;
}

export interface MessagesViewModel {
	draftId: number;
	showMessagesSection: boolean;
	showPostMessageSection: boolean;
	messages: MessageViewModel[];
}

export interface PostMessageModel {
	draftId: number;
	message: string;
}

export const messagesApiSlice = siteApiSlice
	.enhanceEndpoints({
		addTagTypes: ["Messages"],
	})
	.injectEndpoints({
		endpoints: (build) => ({
			messagesPage: build.query<MessagesViewModel, number>({
				query: (draftId) => ({
					url: `/Message/Messages`,
					params: { draftId },
				}),
				providesTags: ["Messages"],
			}),
			getMessages: build.query<MessageViewModel[], number>({
				query: (draftId) => ({
					url: `/Message/GetMessages`,
					params: { draftId },
				}),
				providesTags: ["Messages"],
			}),
			postMessage: build.mutation<boolean, PostMessageModel>({
				query: (payload) => ({
					url: `/Message/PostMessage`,
					method: "POST",
					body: payload,
				}),
				invalidatesTags: ["Messages"],
			}),
		}),
	});

export const { useMessagesPageQuery, useGetMessagesQuery, usePostMessageMutation } =
	messagesApiSlice;
